import { ReactNode } from 'react';

import { DocumentMultiReceiptEntity } from '../../../../generated-api';
import { ResultPageDocument } from '../../defs/types';
import { ExpandTable } from './ExpandTable';

export function expandMultiReceiptTable(record: ResultPageDocument<DocumentMultiReceiptEntity>): ReactNode {
  if (record.error) {
    return;
  }
  return <ExpandTable record={record} />;
}
